import { faTrash } from '@fortawesome/free-solid-svg-icons/faTrash';
import axios from 'axios';
import { formatError } from 'components/utils/FormatData';
import React, { useEffect, useState } from 'react';
import { useAlert } from 'react-alert';
import { URL_API } from '../../constants/settings';
import MyButton from '../form/MyButton';
import MyDialog from '../form/MyDialog';

const TypeProfilRenderer = (props) => {
  const alert = useAlert();
  const [content, setContent] = useState('');
  const [chooseUser, setChooseUser] = useState();
  const [dialogState, setDialogState] = useState();
  const [openDialog, setOpenDialog] = useState(false);

  useEffect(() => {
    if (dialogState) {

      axios({ method: 'delete', url: URL_API + '/utilisateurs/' + chooseUser.login })
        .then(function () {
          alert.success('Le compte utilisateur [' + chooseUser.login + '] a été supprimé avec succès');
          props.setNeedUpdate(true);
        })
        .catch(function (err) {
          formatError(alert, err);
        });

      setChooseUser(null);
      setDialogState(null);
    }
  }, [dialogState]);

  const openModalDeleteUser = () => {
    if (props.data) {
      setChooseUser(props.data);
      setContent(`Êtes-vous sur de vouloir supprimer le compte utilisateur : ${props.data.login}`);
      setOpenDialog(true);
    }
  };

  return (
    <div>
      {
        props.wsStatus &&
        <MyButton className="classic-button" type="button" href="#" iconCenter={{ icon: faTrash, type: 'fontAwesome' }}
          styleCss={{ boxShadow: 'none', color: '#BB0060', height: '25px' }}
          onClick={() => openModalDeleteUser()} />
      }
      {
        !props.wsStatus &&
        <MyButton className="classic-button" type="button" href="#" iconCenter={{ icon: faTrash, type: 'fontAwesome' }}
          styleCss={{ boxShadow: 'none', color: '#8ca0a8', height: '25px', cursor: 'default' }} />
      }

      <MyDialog open={openDialog} handleClose={setOpenDialog} title="Suppression compte utilisateur" content={content} dialog={setDialogState} />
    </div>
  );

};

export default TypeProfilRenderer;